import { FC, useContext } from "react";
import { EcdGenerateReportContext } from "../contexts/EcdGenerateReportContext";
import { Waffles, wafflesKeyColumnName } from "../../../shared/waffles";
import { sharedEcdExportDrillInColumnConfig } from "../flyouts/EcdDrillInConfig";
import { EcdCompositeFillableGapsTableData } from "../flyouts/EcdCompositeFillableGapsFlyout";
import CompositeFillableGapsChart from "../components/CompositeFillableGapsChart";

const CompositeFillableGapsExport: FC = () => {
  const wizardContext = useContext(EcdGenerateReportContext);
  const title = "Composite Fillable Gaps";
  const isEmpty = Object.values(wizardContext.compositeFillableGapsData).every((d) => d === 0);
  const detailData = !isEmpty ? wizardContext.compositeFillableGapsDrillInData.map((row) => {
    return {
      /* eslint-disable sort-keys */
      [wafflesKeyColumnName]: row.customProjectId.toString(),
      projectName: <span>{row.projectName}</span>,
      compositeFillableGaps: row.fillableGapCount.toLocaleString(),
      fillableBySingleProvider: row.fillableByOneGapCount.toLocaleString(),
      unfillableGaps: row.unfillableGapCount.toLocaleString(),
      overallGaps: row.gapCount.toLocaleString(),
      /* eslint-enable sort-keys */
    }
  }) : [];

  //cut off array when rows will exceed one page in export
  if (detailData.length > 15)
    detailData.length = 15;

  return (
    <div className="ecd-export__wrapper">
      <div style={{ width: "50%" }}>
        <h2 className="qes-dashboard-tile__title ecd-export__head">{title}</h2>
        <CompositeFillableGapsChart
          compositeFillableGapsData={wizardContext.compositeFillableGapsData }
          fillableGapsPrimary={wizardContext.fillableGapsPrimary}
          fillableGapsSecondary={wizardContext.fillableGapsSecondary}
          unfillableGaps={wizardContext.unfillableGaps}
        />
      </div>
      <br />
      {(wizardContext.addGraphDetails && !isEmpty) && (
        <div className="ecd-export__table">
          <h2 className="qes-dashboard-tile__title ecd-export__head">{title + " Details"}</h2>
          <Waffles<EcdCompositeFillableGapsTableData>
            columns={sharedEcdExportDrillInColumnConfig}
            data={detailData}
            loading={detailData.length === 0}
            testId="ecd-export-composite-fillable-gaps__table"
            />
        </div>
      )}
    </div>
  );
}

export default CompositeFillableGapsExport;